export default __webpack_public_path__ + "static/media/jyoparishad.b5343777.png";